const ACLGlobalTemplateTypePolicy = {
  ACLGlobalTemplate: {
    //Since BE is not returning unique ids for different objects, we are disabling normalization for this type
    keyFields: false,
  },
};

export default ACLGlobalTemplateTypePolicy;
